export const getImageSource = (baseUrl: string, width: number) => {
  return `${baseUrl}?tr=w-${width}`;
};
